module.exports = __webpack_public_path__ + "img/delete-icon.abcf57b9.svg";